const common = {
  "nav.about": "About",
  "nav.approach": "Our Approach",
  "nav.contact": "Contact",
  "nav.getInTouch": "Get in touch",

  "hero.badge": "Norway \u00b7 Healthcare",
  "hero.title1": "Modern healthcare,",
  "hero.title2": "delivered with care",
  "hero.description": "ExoMed provides modern medical services with a focus on quality, accessibility, and patient-centered care.",
  "hero.learnMore": "Learn more",
  "hero.contactUs": "Contact us",
  "hero.scroll": "Scroll",

  "about.badge": "About ExoMed",
  "about.title1": "A new standard",
  "about.title2": "in medical care",
  "about.p1": "ExoMed was founded on the belief that high-quality medical services should be approachable, clear, and deeply human. We combine clinical expertise with a modern, patient-first philosophy.",
  "about.p2": "Our team is committed to delivering care that is not only medically sound, but also respectful, accessible, and tailored to each individual. We believe that trust is built through consistency, honesty, and genuine attention to every patient.",
  "about.value1Title": "Patient-centered",
  "about.value1Desc": "Every decision we make starts with the patient. We build care models around individual needs and wellbeing.",
  "about.value2Title": "Quality & trust",
  "about.value2Desc": "We uphold the highest standards of clinical quality, transparency, and professional integrity.",
  "about.value3Title": "Accessible care",
  "about.value3Desc": "We believe that modern medical services should be easy to reach, easy to understand, and easy to trust.",

  "tagline.badge": "Our philosophy",
  "tagline.quote1": "\u201cModern healthcare,",
  "tagline.quote2": "delivered with care.\u201d",
  "tagline.description": "We are driven by a simple idea: that every person deserves access to medical care that is kind, clear, and consistently excellent.",
  "tagline.quality": "Quality",
  "tagline.qualitySub": "at every step",
  "tagline.accessible": "Accessible",
  "tagline.accessibleSub": "for everyone",
  "tagline.human": "Human",
  "tagline.humanSub": "always",

  "contact.badge": "Contact",
  "contact.title1": "We\u2019d love to",
  "contact.title2": "hear from you",
  "contact.description": "Have a question or want to learn more about ExoMed? Reach out to us \u2014 we respond to all enquiries promptly and with care.",
  "contact.emailLabel": "Email",
  "contact.phoneLabel": "Phone",
  "contact.firstName": "First name",
  "contact.lastName": "Last name",
  "contact.emailAddr": "Email address",
  "contact.subject": "Subject",
  "contact.message": "Message",
  "contact.send": "Send message",
  "contact.sending": "Sending...",
  "contact.successTitle": "Message sent",
  "contact.successDesc": "Thank you for reaching out. We will get back to you shortly.",
  "contact.sendAnother": "Send another",
  "contact.errorMsg": "Something went wrong. Please try again or email us directly.",
  "contact.charLimit": "Message cannot exceed 500 characters.",

  "footer.description": "Modern medical services with a focus on quality, accessibility, and patient-centered care.",
  "footer.navigation": "Navigation",
  "footer.navAbout": "About",
  "footer.navApproach": "Our Approach",
  "footer.navContact": "Contact",
  "footer.contactTitle": "Contact",
  "footer.rights": "ExoMed. All rights reserved.",
  "footer.tagline": "Norway \u00b7 Modern Healthcare",
  "footer.privacy": "Privacy Policy",

  "personvern.backToHome": "Back to home",
  "personvern.legal": "ExoMed \u00b7 Legal",
  "personvern.title": "Privacy Policy",
  "personvern.subtitle": "This policy describes how ExoMed processes personal data in accordance with the GDPR and Norwegian law.",
  "personvern.lastUpdated": "Last updated:",
  "personvern.contents": "Contents",
  "personvern.contactQ": "Questions about privacy?",
  "personvern.contactD": "Please feel free to contact us if you have questions about how we process your personal data, or if you wish to exercise your rights.",
};

export default common;
